import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Container from "./Container.jsx";
import Entity from "../datasource/Entity";
import clientConfig from "../config/client";
import { Box } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import GridPeriodResidence from "../components/Views/GridPeriodResidence.jsx";
import sortBy from "lodash/sortBy";

class PeriodResidenceContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("period_residence");
        this.state = { ...this.state, loadAfterChangedByRule: false };
    }

    componentDidMount = async () => {
        await this.getAuxData();
    };

    render = () => {
        if (this.state.error && this.state.error.status == 403) {
            return <Route render={() => <Redirect to="/hotels" replace />} />;
        }

        const routes = this.datasource.routes();
        const { history } = this.props;
        const auxDataRoomTypes =
            this.props?.auxData?.room_types &&
            this.props.auxData.room_types.filter((t) => t.active);
        const sortedAux = sortBy(auxDataRoomTypes, "order");
        const auxDataRates =
            this.props?.auxData?.rates_short && this.props.auxData.rates_short;

        const gridPeriodResidence =
            !auxDataRoomTypes || !auxDataRates ? (
                <Box mt={4}>
                    <LinearProgress mt={3} />
                </Box>
            ) : sortedAux.length > 0 ? (
                <Box p={3}>
                    <Route path={routes.home} exact>
                        <GridPeriodResidence
                            loading={this.state.loading}
                            auxData={sortedAux}
                            initAction={this.getAllItems}
                            items={this.state.AllItems}
                            objectTemplate={this.datasource.getEmptyObject()}
                            submitAction={this.updateAllItems}
                            errorFields={this.state.error}
                            updateAction={this.setItems}
                            rates={auxDataRates}
                            globalSearch={this.globalSearch}
                            updateGlobalSearch={this.updateGlobalSearch}
                            history={history}
                            openLeftMenu={this.props.openLeftMenu}
                            hotelId={this.props.match.params.mainId}
                        />
                    </Route>{" "}
                </Box>
            ) : (
                <Typography>Отсутствуют внесенные категории номеров</Typography>
            );

        return (
            <Paper elevation={3}>
                <Box p={3}>
                    <Typography mb={3} variant={"h5"}>
                        Срок проживания
                    </Typography>
                </Box>
                {gridPeriodResidence}
            </Paper>
        );
    };
}

export default PeriodResidenceContainer;
